import { useEffect, useMemo, useState } from 'react';
import { useVariable } from '../../../services/backstage/BackstageProvider';

export const useAvatarImage = (src?: string | null) => {
  const apiUrl = useVariable('apiUrl')?.replace('/graphql', '');
  const [imageFailed, setImageFailed] = useState(false);

  const resolvedSrc = useMemo(() => {
    if (!src) {
      return undefined;
    }

    return src.startsWith('/') ? `${apiUrl}${src}` : src;
  }, [apiUrl, src]);

  useEffect(() => {
    setImageFailed(false);
  }, [resolvedSrc]);

  return {
    resolvedSrc,
    canRenderImage: !!resolvedSrc && !imageFailed,
    handleImageError: () => setImageFailed(true)
  };
};
